import React from 'react';

interface NobelDividerProps {
    className?: string;
    style?: React.CSSProperties;
}

/**
 * Nobel Divider - Horizontal gold accent line
 */
export const NobelDivider: React.FC<NobelDividerProps> = ({ className = '', style }) => {
    return (
        <div
            className={`nobel-divider ${className}`}
            style={style}
        />
    );
};
